@if (vm$ | async; as vm) {
  <nty-page (refresh)="handleRefresh()">
    <nty-toolbar nty-header title="Notifications">
      <nty-top-toolbar-content>
        <button class="mark-all-read-btn" (click)="onMarkAllAsRead()">Mark all as read</button>
      </nty-top-toolbar-content>
      <nty-toolbar-bottom-content>
        <div class="filter-pills">
          @for (filter of filterOptions; track filter) {
            <ion-chip [class.selected]="vm.filterBy === filter.value" (click)="onFilterChange(filter.value)">
              {{ filter.label }}
            </ion-chip>
          }
        </div>
      </nty-toolbar-bottom-content>
    </nty-toolbar>
    <!-- Notification list -->
    @if (vm.notifications.length > 0) {
      <div class="notifications-list">
        @for (notification of vm.notifications; track notification.id) {
          <nty-notification-card
            [notification]="notification"
            [language]="language$ | async"
            (cardClick)="onNotificationClick(notification)"
            (toggleReadStatus)="onToggleReadStatus(notification)" />
        }
      </div>
    }
    @if (!vm.hasMore) {
      <div class="end-of-list">
        <terra-icon icon="confetti" variant="regular" [size]="48" />
        That's all your notifications from the past 90 days.
      </div>
    }
    <!-- Infinite scroll: use *ngIf instead of [disabled] so the component is destroyed
    when there's no more data and recreated fresh after a refresh, avoiding stale
    internal state from disabled→enabled transitions. -->
    @if (vm.hasMore) {
      <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
        <ion-infinite-scroll-content loadingSpinner="crescent" />
      </ion-infinite-scroll>
    }
  </nty-page>
}
